var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart-block" },
    [
      _vm._l(_vm.items, function(item, index) {
        return _c("BasketItem", {
          key: item.ID,
          attrs: { item: item },
          on: { change: _vm.onChangeItem, remove: _vm.onRemoveItem }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cart-block__item grid-column-2 mobile-column-1" },
        [
          _c("div", { staticClass: "common-flex mobile-column" }, [
            _vm._v(" ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-column-2" }, [
            _c("span", { staticClass: "cart-item-text" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "cart-item-text common-flex direction-column" },
              [
                _c("span", { staticClass: "cart-item-label" }, [
                  _vm._v("ИТОГО")
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.totalSum) +
                    "р\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "cart-item-text" }, [_vm._v(" ")]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "cart-item-button common-flex direction-column" },
      [
        _c(
          "button",
          {
            staticClass: "common-button",
            attrs: { onclick: "document.location = '/checkout/'" }
          },
          [_vm._v("Оформить заказ")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }